export default __webpack_public_path__ + "static/media/chicago.b878a185.png";